import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Skeleton } from '@mui/material';

interface Props {
    label: string | React.ReactNode;
    children: any;
    test?: string;
    loading?: boolean;
}

const CustomBlock = ({ label, children, test, loading = false }: Props) => (
    <Box
        sx={{
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
            gap: 1,
            height: '100%',
            overflowY: 'auto',
        }}
        data-cy={test}
    >
        <Typography fontWeight={700} fontSize={18}>
            {loading ? <Skeleton width={200} /> : label}
        </Typography>

        <Box
            sx={{
                display: 'grid',
                gridTemplateRows: '1fr',
                borderTop: '2px solid #C4D600',
                bgcolor: 'white',
                height: '100%',
                overflowY: 'auto',
                position: 'relative',
            }}
        >
            {children}
        </Box>
    </Box>
);

export default CustomBlock;
